export default __webpack_public_path__ + "static/media/Tabl_7.6c1ca179.svg";